import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  container: {
    backgroundColor: '#fff',
    boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '4px',
    maxWidth: '160%',
    padding: '0 16px 0 0',
    cursor: 'pointer',
    zIndex: 9999,
    position: 'absolute',
    top: '120%',
    right: 0,
  },
  item: {
    fontSize: '14px',
    whiteSpace: 'nowrap',
  },
  alignToLeft: {
    left: 0,
    right: 'auto',
  },
}));
